import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  data: any;
  loading: boolean;
  success: boolean;
  error: string;
  editMode: boolean;
}

const initialState: InitialState = {
  data: null,
  loading: null,
  success: null,
  error: null,
  editMode: true,
};

const profile = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileEditMode: (state, action) => {
      return {
        ...state,
        editMode: action.payload,
      };
    },
    setProfileDataLoading: (state, action) => {
      return {
        ...state,
        loading: action.payload,
        error: null,
        success: null,
      };
    },
    setProfileData: (state, action) => {
      return {
        ...state,
        data: action.payload,
        error: null,
        success: true,
      };
    },
    updateProfileData: (state, action) => {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
        success: true,
      };
    },
    setProfileDataError: (state, action) => {
      return {
        ...state,
        data: null,
        success: false,
        error: action.payload,
      };
    },
  },
});

export const {
  setProfileEditMode,
  setProfileData,
  updateProfileData,
  setProfileDataLoading,
  setProfileDataError,
} = profile.actions;

export default profile.reducer;
